import React, { useEffect } from 'react';
import { requestPermission } from '../util/firebase';
import { Layout } from 'antd';
import Header from '../components/common/layout/Header';
import LoginContainer from '../containers/LoginContainer';
const { Content } = Layout;

const LoginPage: React.FC = () => {

  useEffect(() => {
    const initialize = async () => {
      await requestPermission();
    };
    initialize().then(() => {
      console.log('initialize complete');
    });
  }, []);


  return (
    <Layout>
      <Header/>
      <Layout style={{ padding: '0 24px 24px' }}>
        <Content style={{ padding: '24', margin: '0', minHeight: '280' }}>
          <LoginContainer/>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LoginPage;
